import React from 'react';
import LottieView from 'lottie-react-native';
import { AspectRatioToken, } from '@voltmoney/schema';
import ThemeProvider from '@voltmoney/theme';
import { lottieTokensMap } from './LottieRegistry';
import { Platform } from 'react-native';
const Lottie = ({ uri, size, autoplay = true, aspectRatio = AspectRatioToken.A1_1, loop = true, }) => {
    const theme = ThemeProvider.getTheme();
    console.log('Lottie map receeived is', uri);
    const sizeValue = theme.lottieSize[size];
    const aspectRatioValue = theme.aspectRatio[aspectRatio];
    if (!uri && !size)
        return React.createElement(React.Fragment, null);
    return uri === 'loading' &&
        Platform.OS === 'ios' ? (React.createElement(LottieView, { source: {
            uri: 'https://lottie.host/9554f7b1-1ff3-47b3-9c70-a177d99da0aa/IdThFBEdRV.json',
        }, style: {
            width: sizeValue,
            height: 'auto',
            aspectRatio: aspectRatioValue,
        }, autoPlay: autoplay, loop: false })) : (React.createElement(LottieView, { source: lottieTokensMap[uri], style: {
            width: sizeValue,
            height: 'auto',
            aspectRatio: aspectRatioValue,
        }, autoPlay: autoplay, loop: loop }));
};
export default React.memo(Lottie);
export { Lottie };
